export const testimonials = [
  {
    name: "Marcus J.",
    role: "Sneaker Collector, NYC",
    rating: 5,
    title: "Best pandabuy spreadsheet I've found",
    text: "I've been searching for a reliable pandabuy spreadsheet for months. This one is updated daily and the quality ratings are spot on. Found some incredible sneakers through the shoes category.",
  },
  {
    name: "Elena R.",
    role: "Streetwear Enthusiast, London",
    rating: 5,
    title: "Saves me hours every week",
    text: "Instead of scrolling through endless threads, I just check the pandabuy spreadsheet here. The hoodies and t-shirts sections are always packed with fresh finds. It's become my go-to resource for fashion hauls.",
  },
  {
    name: "David K.",
    role: "Fashion Reseller, Los Angeles",
    rating: 5,
    title: "Incredible value for resellers",
    text: "As someone who sources products regularly, this pandabuy spreadsheet database is a goldmine. The category organization makes it easy to find trending items across jackets, accessories, and bags fast.",
  },
  {
    name: "Sophie L.",
    role: "Budget Shopper, Toronto",
    rating: 4,
    title: "Found amazing budget gems",
    text: "The budget picks in this pandabuy spreadsheet are seriously underrated. I've ordered multiple items from the accessories and headwear sections and the quality exceeded my expectations every time.",
  },
  {
    name: "James T.",
    role: "TikTok Creator, Miami",
    rating: 5,
    title: "My secret weapon for content",
    text: "Half the items I review on my channel come from this pandabuy spreadsheet. The trending section helps me stay ahead of viral finds, and my followers love the curated picks I share.",
  },
  {
    name: "Amira H.",
    role: "Online Shopper, Dubai",
    rating: 5,
    title: "Finally, organized fashion finds",
    text: "I used to save random links everywhere. This pandabuy spreadsheet system changed everything. The jersey and sets categories helped me put together complete outfits without the guesswork.",
  },
];